//import App from './App'
import Message from "./BaseMessage"
import config from "./config";

/*let nativeComponentMap = {}
document.addEventListener('nativeComponentCreated', function (event) {
    const { id, instance } = event.param
    nativeComponentMap[id] = instance
})*/


function fireEvent(eventName, eventData) {
    var ev = document.createEvent('HTMLEvents')
    ev.initEvent(eventName, false, true)
    ev.param = eventData
    document.dispatchEvent(ev)
}




class WebviewMessage extends Message {
    constructor() {
        super()
    }

    /*broadcast(eventName, data) {
        const unitId = config.unitId
        console.log('发送广播', eventName, data)
        return callNative({fnName: 'VideoBridge/broadcast', params:{unitId, eventName, data}})
    }*/

    onBroadcastAll(cb){
        document.addEventListener('broadcast', function (event) {
            cb(event.param)
        }, false)
    }

    onBroadcast(bindEventName, cb) {
        document.addEventListener('broadcast', function (event) {
            // console.log('监听到广播!!!!', event, event.param.eventName,  bindEventName, event.param.data && event.param.data.eventName)
            const { eventName, data } = event.param
            if(eventName === bindEventName){
                cb(event.param)
            }
        }, false)
    }

    //考虑删除
    /*onSubViewEmitMessage(eventName, cb) {
        this.onBroadcast('webviewEmitMessage', (event)=>{
            // console.log('收到EmitMessage onSubViewEmitMessage ===>',event,nativeComponentMap,nativeComponentMap[event.data.id],eventName,event.data.eventName)
            const { data={} } = event
            if(config.nativeComponentMap[data.id] && data.id!==config.rootWebviewId && eventName===data.eventName){
                console.warn('收到指定的 ==》 EmitMessage', event,config.nativeComponentMap,config.nativeComponentMap[data.id],eventName,data.eventName)
                cb && cb(data.data)
            }
        })
    }*/

    //考虑删除
    /*onSuperViewEmitMessage(eventName, cb) {
        this.onBroadcast('emitMessageToView', (event)=>{
            const { data={} } = event
            if(data.id === config.rootWebviewId && eventName===data.eventName){
                cb && cb(data.data)
            }
        })
    }*/

    //向特定视图发送消息 （使用onSuperViewEmitMessage方法接收消息）
    emitMessageToView(view, eventName, data = {}) {
        const _params = {
            id: view.id,
            eventName,
            data
        }
        return this.broadcast(Message.MSG_TO_SPECIFIED_VIEW, _params)
    }

    //向父视图发送消息  emitMessageToSuperView
    emitMessageToSuperView(eventName, data = {}) {
        const _params = {
            id: config.webviewId,
            eventName,
            data
        }
        console.log('emitMessageToSuperView',_params)
        return this.broadcast(Message.MSG_TO_SUPER_VIEW, _params)
    }

}


export default WebviewMessage